import React from "react";
import { Link, useLocation } from "react-router-dom";

const ServiceArea = [
  {
    label: "Merkez Mahallesi Halı Yıkama",
    path: "/avcilar/merkez-hali-yikama",
    description:
      "Avcılar Merkez Mahallesi'nde tam otomatik makinelerle hijyenik ve derinlemesine halı yıkama hizmeti sunuyoruz."
  },
  {
    label: "Mustafa Kemal Paşa Mahallesi Halı Yıkama",
    path: "/avcilar/mustafa-kemal-pasa-hali-yikama",
    description:
      "Mustafa Kemal Paşa Mahallesi'nde halılarınızı evinizden alıyor, en kısa sürede temizlenmiş şekilde teslim ediyoruz."
  },
  {
    label: "Cihangir Mahallesi Halı Yıkama",
    path: "/avcilar/cihangir-hali-yikama",
    description:
      "Cihangir Mahallesi'nde antibakteriyel ürünlerle garantili ve çevre dostu halı yıkama hizmeti veriyoruz."
  },
  {
    label: "Ambarlı Halı Yıkama",
    path: "/avcilar/ambarlı-hali-yikama",
    description:
      "Ambarlı semtine özel hızlı servisimizle halılarınızı özenle yıkıyor, zamanında teslim ediyoruz."
  },
  {
    label: "Gümüşpala Mahallesi Halı Yıkama",
    path: "/avcilar/gumuspala-hali-yikama",
    description:
      "Gümüşpala Mahallesi'nde halı yıkama ihtiyaçlarınızı uzman kadromuzla kaliteli ve ekonomik şekilde karşılıyoruz."
  },
  {
    label: "Denizköşkler Mahallesi Halı Yıkama",
    path: "/avcilar/denizkoskler-hali-yikama",
    description:
      "Denizköşkler Mahallesi'nde tam hijyen garantili halı temizliği, kapıdan alım ve teslimat dahil olarak sunulur."
  },
  {
    label: "Firuzköy Halı Yıkama",
    path: "/avcilar/firuzkoy-hali-yikama",
    description:
      "Firuzköy bölgesinde halılarınızı profesyonel makinelerde, el değmeden hijyenik şekilde yıkıyoruz."
  }
];

const AvcilarSidebar = () => {
  const location = useLocation();

  return (
    <div className="mt-2 text-[#003132]">
      <h2 className="text-lg font-semibold mb-2 uppercase tracking-wide text-center">AVCILAR SERVİS ALANLARI</h2>

      <div className="bg-[#f1f5f9] p-4 rounded-xl shadow-sm space-y-3 border border-gray-200">
        {ServiceArea.map((area, index) => (
          <div key={index}>
            <Link
              to={area.path}
              className={`block text-sm font-semibold px-3 py-1 rounded-lg transition-all duration-200 ${
                location.pathname === area.path
                  ? "bg-red-600 text-white"
                  : "text-red-900 hover:bg-green-100 hover:text-red-800"
              }`}
            >
              {area.label}
            </Link>
            <p className="text-xs text-gray-600 mt-1 pl-1">{area.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AvcilarSidebar;
